// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  /* height: 80px; */
  /* width: 90%; */
  margin: 100px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  /* position: sticky; */
  /* bottom: 0; */
  /* padding: 0 40px; */
}

.foot {
  position: relative;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-logo {
  /* width: 145px; */
  width: 9rem;
  height: 50px;
  color: #fff;
  justify-self: start;
  text-decoration: none;
  font-size: 1rem;
  display: flex;
  align-items: center;
}

.nav-menuuu {
  font-family: inter;
  display: grid;
  grid-template-columns: repeat(4, auto);
  grid-gap: 15px;
  list-style: none;
  text-align: center;
  width: 50vw;

  /* background-color: red; */
  justify-content: center;
  margin-right: 1rem;
}

.nav-item {
  height: 30px;
}

.middle-menu {
  align-items: center;
  /* margin: auto 2rem; */
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.middle-menu li {
  align-items: center;
  font-weight: 300;
  font-family: inter;
  position: sticky;
  font-size: 18px;
}

.nav-link {
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;
}

.nav-link:hover {
  transition: all 0.2s ease-out;
}

.fa-bars {
  color: #fff;
}

.nav-links-mobile {
  display: none;
}



/* Social Icons */

.social-icon-link i {
  color: #fff;
  font-size: 20px;
  border-radius: 50%;
}

.social-icon-link i:hover {
  color: #ffecd9;
}

.social-icons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* width: 260px; */
}

.logo {
  width: 145px;
  color: #fff;
  justify-self: start;
  margin-left: 20px;
  cursor: pointer;
  text-decoration: none;
  font-size: 2rem;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.media-wrap {
  font-size: 10px;
  border-radius: 50%;
  padding: 6px;
  margin-right: 8px;
  border: 4px solid #4b4b4b40;
  height: 40px;
  align-items: center;
}

.media-wrap:hover {
  border-color: rgba(251, 133, 0, 0.35);
  background: linear-gradient(90deg, rgba(255, 107, 53, 0.15), rgba(251, 133, 0, 0.15));
  transition: background 0.2s ease, border-color 0.2s ease;
}

.website-rights {
  color: #fff;
  margin-bottom: 16px;
}

footer > div {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 2% 20px;
  left: 0;
  right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;;EAEX,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;;;AAIA,iBAAiB;;AAEjB;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,qFAAqF;EACrF,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,OAAO;EACP,QAAQ;AACV","sourcesContent":[".footer {\n  /* height: 80px; */\n  /* width: 90%; */\n  margin: 100px auto 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.2rem;\n  /* position: sticky; */\n  /* bottom: 0; */\n  /* padding: 0 40px; */\n}\n\n.foot {\n  position: relative;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.footer-logo {\n  /* width: 145px; */\n  width: 9rem;\n  height: 50px;\n  color: #fff;\n  justify-self: start;\n  text-decoration: none;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n}\n\n.nav-menuuu {\n  font-family: inter;\n  display: grid;\n  grid-template-columns: repeat(4, auto);\n  grid-gap: 15px;\n  list-style: none;\n  text-align: center;\n  width: 50vw;\n\n  /* background-color: red; */\n  justify-content: center;\n  margin-right: 1rem;\n}\n\n.nav-item {\n  height: 30px;\n}\n\n.middle-menu {\n  align-items: center;\n  /* margin: auto 2rem; */\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.middle-menu li {\n  align-items: center;\n  font-weight: 300;\n  font-family: inter;\n  position: sticky;\n  font-size: 18px;\n}\n\n.nav-link {\n  color: #fff;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  height: 100%;\n}\n\n.nav-link:hover {\n  transition: all 0.2s ease-out;\n}\n\n.fa-bars {\n  color: #fff;\n}\n\n.nav-links-mobile {\n  display: none;\n}\n\n\n\n/* Social Icons */\n\n.social-icon-link i {\n  color: #fff;\n  font-size: 20px;\n  border-radius: 50%;\n}\n\n.social-icon-link i:hover {\n  color: #ffecd9;\n}\n\n.social-icons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* width: 260px; */\n}\n\n.logo {\n  width: 145px;\n  color: #fff;\n  justify-self: start;\n  margin-left: 20px;\n  cursor: pointer;\n  text-decoration: none;\n  font-size: 2rem;\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.media-wrap {\n  font-size: 10px;\n  border-radius: 50%;\n  padding: 6px;\n  margin-right: 8px;\n  border: 4px solid #4b4b4b40;\n  height: 40px;\n  align-items: center;\n}\n\n.media-wrap:hover {\n  border-color: rgba(251, 133, 0, 0.35);\n  background: linear-gradient(90deg, rgba(255, 107, 53, 0.15), rgba(251, 133, 0, 0.15));\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.website-rights {\n  color: #fff;\n  margin-bottom: 16px;\n}\n\nfooter > div {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 2% 20px;\n  left: 0;\n  right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
